import { createSpinner } from './utils';

let canBeLoaded = true;
let bottomOffset = window.innerHeight / 2;
let documentHeight = document.documentElement.scrollHeight;
let documentScrollTop = 0;

const gridContainer = document.querySelector('.ebert__grid');
const loading = createSpinner();


/**
 * Core reusable load-more function.
 * Can be triggered manually or by event listeners.
 */
export async function ajax_loadmore_gallery_items( lightbox ) {

	if ( ! gridContainer ) {
		return;
	}

	bottomOffset = window.innerHeight / 2;
	documentHeight = document.documentElement.scrollHeight;
	documentScrollTop = window.pageYOffset;

	// set always to full height when lightbox is active
	if ( lightbox !== null ) {
		documentScrollTop = documentHeight;
	}

	if (
		( documentScrollTop + window.innerHeight ) > ( documentHeight - bottomOffset ) &&
		canBeLoaded == true &&
		data_params.current_page < data_params.max_page
	) {

		canBeLoaded = false;
		document.body.appendChild( loading );

		const data = {
			'action': 'portfolio_more',
			'security': data_params.ajaxnonce,
			'query': data_params.posts,
			'page': data_params.current_page
		};

		const params = new URLSearchParams();
		for ( const [key, value] of Object.entries(data) ) {
			params.append(key, value);
		}

		try {

			const response = await fetch( data_params.ajaxurl, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded'
				},
				body: params
			});

			if ( !response.ok ) {
				throw new Error(`Network response was not ok (${response.status})`);
			}

			const html = await response.text();

			if ( html ) {

				// Convert to Dom elements
				const parser = new DOMParser();
				const doc = parser.parseFromString(html, 'text/html');
				const items = doc.querySelectorAll('li');

				// Add response data to container
				items.forEach( li => {

					// add to grid
					gridContainer.appendChild(li);

					// push to lightbox array
					const link = li.querySelector('a');
					if ( lightbox ) {
						lightbox.items.push(link);
					}

				});
			}

		}
		catch ( error ) {
			console.error('Error in fetch operation:', error);
		}
		finally {
			loading.remove();
			canBeLoaded = true; // the ajax is completed, now we can run it again
			data_params.current_page++;
			documentHeight = document.documentElement.scrollHeight;
		}
	}

}


export function theme_LoadMorePosts() {

	ajax_loadmore_gallery_items(null); // run once on init

	window.addEventListener( "scroll", (e) => {
		ajax_loadmore_gallery_items(null);
	});

	window.addEventListener( "resize", (e) => {
		ajax_loadmore_gallery_items(null);
	});

}
